import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const APPLE_PLACEHOLDER_FIRST_NAMES = new Set(["apple", "apple user"]);
const APPLE_PLACEHOLDER_LAST_NAMES = new Set(["apple"]);

function normalizeNamePart(value: string | null | undefined): string {
  return String(value ?? "").trim().toLowerCase();
}

/** Valeurs placeholder renvoyées par le backend après création compte Apple. */
export function isPlaceholderFirstName(value: string | null | undefined): boolean {
  const normalized = normalizeNamePart(value);
  return !normalized || APPLE_PLACEHOLDER_FIRST_NAMES.has(normalized);
}

export function isPlaceholderLastName(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): boolean {
  const first = normalizeNamePart(firstName);
  const last = normalizeNamePart(lastName);
  if (!last) {
    return true;
  }
  if (APPLE_PLACEHOLDER_LAST_NAMES.has(last)) {
    return true;
  }
  return first === "apple" && last === "user";
}

export function isGenericAppleUserDisplayName(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): boolean {
  const combined = `${String(firstName ?? "").trim()} ${String(lastName ?? "").trim()}`
    .trim()
    .toLowerCase();
  return combined === "apple user";
}

export function hasValidProfileEmail(email: string | null | undefined): boolean {
  const value = String(email ?? "").trim();
  if (!value) {
    return false;
  }
  return EMAIL_PATTERN.test(value);
}

export function isCompleteProfileIdentity(userClient: any): boolean {
  if (!userClient) {
    return false;
  }
  const first = userClient.first_name;
  const last = userClient.last_name;
  if (
    isPlaceholderFirstName(first) ||
    isPlaceholderLastName(first, last) ||
    isGenericAppleUserDisplayName(first, last)
  ) {
    return false;
  }
  return hasValidProfileEmail(userClient.email);
}

/**
 * Profil à compléter après auto-création compte Apple (noms génériques / e-mail manquant).
 */
export function needsProfileCompletion(userClient: any): boolean {
  if (!userClient) {
    return false;
  }
  return !isCompleteProfileIdentity(userClient);
}

export function notPlaceholderNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || String(value).trim() === "") {
      return null;
    }
    const normalized = normalizeNamePart(value);
    if (APPLE_PLACEHOLDER_FIRST_NAMES.has(normalized)) {
      return { placeholderName: true };
    }
    if (normalized === "user") {
      return { placeholderName: true };
    }
    return null;
  };
}
